unit UMaterialListForm;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.StdCtrls, WEBLib.StdCtrls, UMainConfig,
  Vcl.Imaging.pngimage, Vcl.Controls, WEBLib.ExtCtrls, Types, Vcl.Grids,
  WEBLib.Grids, UVmPosList, WEBLib.Buttons, UWebBarcodeScanner, UVmPosModel,
  UWebSpeechRec, UMatModel, UVmPosForm, UFakModel;

type
  TMaterialListForm = class(TForm)
    pnlHeader: TPanel;
    imgLogo: TImageControl;
    lblHeader: TLabel;
    btnBack: TImageControl;
    pnlFooter: TPanel;
    pnlButtons: TPanel;
    pnlMaterialList: TPanel;
    sgMaterialList: TStringGrid;
    btnBarcode: TBitBtn;
    btnMicOn: TBitBtn;
    btnMicOff: TBitBtn;
    btnKeyboard: TBitBtn;
    pnlSmallButtons: TPanel;
    pnlInfo: TPanel;
    lblInfo: TLabel;
    btnEdit: TBitBtn;
    btnDelete: TBitBtn;
    btnLoad: TBitBtn;
    btnTake: TBitBtn;
    procedure WebFormResize(Sender: TObject);
    procedure btnBackClick(Sender: TObject);
    [Async]
    procedure btnBarcodeClick(Sender: TObject); async;
    procedure sgMaterialListSelectCell(Sender: TObject; ACol, ARow: Integer;
      var CanSelect: Boolean);
    procedure btnMicOffClick(Sender: TObject);
    procedure btnMicOnClick(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
    procedure btnKeyboardClick(Sender: TObject);
    [Async]
    procedure btnEditClick(Sender: TObject); async;
    procedure btnDeleteClick(Sender: TObject);
    procedure btnLoadClick(Sender: TObject);
    procedure sgMaterialListClickCell(Sender: TObject; ACol, ARow: Integer);
    procedure btnTakeClick(Sender: TObject);
    procedure WebFormClose(Sender: TObject; var Action: TCloseAction);
    procedure WebFormOrientationChange(Sender: TObject;
      AOrientation: TScreenOrientation);
  private
    FMainConfig: TMainConfig;
    FFak: TFakModel;
    FVmPosList: TVmPosList;
    FBarcodeScanner: TBarcodeScanner;
    FSelectedItem: TVmPosModel;
    FVmPosForm: TVmPosForm;
    FSource: TObject;
    FPosList: TVmPosList;
    FReportMode: Boolean;
    [Async]
    procedure ContinueSuccess(Mat: TMatModel); async;
    procedure HandleError(Sender: TObject; AMsg: string);
    procedure HandlePropertyChanged(Sender: TObject; PropertyName: string);
    procedure HandleSpeechRecCommand(Sender: TObject;
      SpeechRecCommand: TSpeechRecCommand; Parameters: TStrings);
    procedure HandleSpeechRecNoresultMatch(Sender: TObject; Phrases: TStrings);
    procedure SgMaterialListFill(Sender: TObject);
    procedure SetMainConfig(const Value: TMainConfig);
    procedure SetFak(const Value: TFakModel);
    procedure SetVmPosList(const Value: TVmPosList);
    procedure SetSelectedItem(const Value: TVmPosModel);
    procedure SetReportMode(const Value: Boolean);
  public
    procedure EnableButtons(Value: Boolean);
    property MainConfig: TMainConfig read FMainConfig write SetMainConfig;
    property Fak: TFakModel read FFak write SetFak;
    property VmPosList: TVmPosList read FVmPosList write SetVmPosList;
    property SelectedItem: TVmPosModel read FSelectedItem write SetSelectedItem;
    property ReportMode: Boolean read FReportMode write SetReportMode;
  protected procedure LoadDFMValues; override; end;

var
  MaterialListForm: TMaterialListForm;

implementation

uses
  UEssentialHelper, WEBLib.Storage, UBarcodeScannerForm, UMatList, Math;

{$R *.dfm}
{ TMaterialListForm }

procedure TMaterialListForm.btnBackClick(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  Self.ModalResult := mrNone;
  Self.Close;
end;

procedure TMaterialListForm.btnBarcodeClick(Sender: TObject);
var
  frm: TBarcodeScannerForm;
begin
  Self.MainConfig.TimerReset;
  FSource := btnBarcode;
  frm := TBarcodeScannerForm.Create(Self);
  frm.Caption := Self.Caption;
  frm.Popup := false;
  await(TBarcodeScannerForm, frm.Load);
  frm.MainConfig := Self.MainConfig;
  try
    Self.Hide;
    await(TModalResult, frm.Execute);
    if frm.Mat <> nil then
      Self.ContinueSuccess(frm.Mat);
  finally
    Self.Show;
    Self.WebFormResize(Sender);
    frm.Free;
  end;
end;

procedure TMaterialListForm.btnDeleteClick(Sender: TObject);
var
  s: string;
  procedure HandleResult(Result: TModalResult);
  var
    index: Integer;
  begin
    if Result = mrYes then
    begin
      index := VmPosList.IndexOf(SelectedItem);
      if index >= 0 then
        VmPosList.Delete(index);
      SelectedItem := nil;
    end;
  end;

begin
  Self.MainConfig.TimerReset;
  s := 'Möchten Sie die Position' + #13#10;
  s := s + Self.SelectedItem.Mat.Bezeichnung + ' ' +
    FloatToStr(Self.SelectedItem.Menge) + ' ' +
    Self.SelectedItem.Mat.MeEinheit + #13#10;
  s := s + 'jetzt löschen?';
  MessageDLG(s, mtConfirmation, [mbYes, mbNo], @HandleResult);
end;

procedure TMaterialListForm.btnEditClick(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  if FVmPosForm = nil then
    FVmPosForm := TVmPosForm.Create(Self);
  FVmPosForm.Caption := Self.Caption;
  FVmPosForm.Popup := false;
  await(TVmPosForm, FVmPosForm.Load);
  FVmPosForm.MainConfig := Self.MainConfig;
  FVmPosForm.VmPos := Self.SelectedItem;
  try
    Self.Hide;
    await(TModalResult, FVmPosForm.Execute);
  finally
    Self.Show;
    FVmPosForm.Free;
    FVmPosForm := nil;
  end;
end;

procedure TMaterialListForm.btnKeyboardClick(Sender: TObject);
var
  code: string;
  Mat: TMatModel;
  lst: TMatList;
  procedure SuccessHandling(Sender: TObject);
  begin
    if Sender is TMatModel then
    begin
      Mat := Sender as TMatModel;
      lst.Add(Mat);
      Self.ContinueSuccess(Mat);
    end;
  end;
  procedure ErrorHandling(Sender: TObject; AMsg: string);
  begin
    Mat := lst.GetByCode(code);
    if Mat = nil then
      Self.HandleError(Mat, AMsg)
    else
      Self.ContinueSuccess(Mat);
  end;

begin
  Self.MainConfig.TimerReset;
  FSource := btnKeyboard;
  if InputQuery('Tastatureingabe', 'Artikel-Nr. oder EAN-Code', code) then
  begin
    lst := TMatList.Create(true);
    Mat := TMatModel.Create;
    Mat.OnError := ErrorHandling;
    Mat.OnSuccess := SuccessHandling;
    Mat.GetByCode(Self.MainConfig.Uri, code);
  end;
end;

procedure TMaterialListForm.btnLoadClick(Sender: TObject);
  procedure HandleListChanged(Sender: TObject);
  var
    i, index: Integer;
  begin
    if Sender is TVmPosList then
    begin
      FPosList := Sender as TVmPosList;
      for i := 0 to FPosList.Count - 1 do
      begin
        index := Self.VmPosList.IndexOf(FPosList.Items[i]);
        if index = -1 then
          Self.VmPosList.Add(FPosList.Items[i]);
      end;
      Self.VmPosList.Sort;
    end;
  end;

begin
  Self.MainConfig.TimerReset;
  if FPosList = nil then
  begin
    FPosList := TVmPosList.Create;
    FPosList.Fak := Self.Fak;
    FPosList.Url := Self.MainConfig.Uri;
    FPosList.PersonalNr := Self.MainConfig.User.PersonalNr;
  end;
  FPosList.Clear;
  FPosList.OnError := Self.HandleError;
  FPosList.OnListChanged := HandleListChanged;
  FPosList.GetAll;
end;

procedure TMaterialListForm.btnMicOffClick(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  Self.MainConfig.SpeechRec.Stopp;
end;

procedure TMaterialListForm.btnMicOnClick(Sender: TObject);
begin
  FSource := btnMicOn;
  Self.MainConfig.TimerReset;
  Self.MainConfig.SpeechRec.Start;
end;

procedure TMaterialListForm.btnTakeClick(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  Self.ModalResult := mrOK;
  Self.Close;
end;

procedure TMaterialListForm.ContinueSuccess(Mat: TMatModel);
var
  model: TVmPosModel;
begin
  FVmPosForm := TVmPosForm.Create(Self);
  FVmPosForm.Caption := Self.Caption;
  FVmPosForm.Popup := false;
  await(TVmPosForm, FVmPosForm.Load);
  FVmPosForm.MainConfig := Self.MainConfig;
  if FSource = btnBarcode then
    FVmPosForm.Mode := imScanner;
  if FSource = btnKeyboard then
    FVmPosForm.Mode := imKeyboard;
  if FSource = btnMicOn then
    FVmPosForm.Mode := imMic;
  model := TVmPosModel.Create;
  model.Fak := Self.Fak;
  model.PersonalNr := Self.MainConfig.User.PersonalNr;
  model.Name := Self.MainConfig.User.Name;
  model.Vorname := Self.MainConfig.User.Vorname;
  model.Mat := Mat;
  FVmPosForm.VmPos := model;
  try
    Self.Hide;
    await(TModalResult, FVmPosForm.Execute);
    if FVmPosForm.VmPos <> nil then
      Self.VmPosList.Insert(0, FVmPosForm.VmPos);
  finally
    Self.btnMicOffClick(nil);
    FVmPosForm.Hide;
    Self.Show;
    FVmPosForm.Free;
    FVmPosForm := nil;
  end;
end;

procedure TMaterialListForm.EnableButtons(Value: Boolean);
begin
  btnBarcode.Visible := Value;
  btnKeyboard.Visible := Value;
  btnMicOn.Visible := Value;
end;

procedure TMaterialListForm.HandleError(Sender: TObject; AMsg: string);
begin
  MessageDLG(AMsg, mtError, [mbOK], nil);
end;

procedure TMaterialListForm.HandlePropertyChanged(Sender: TObject;
  PropertyName: string);
begin
  if PropertyName = 'Selected' then
    Self.SgMaterialListFill(Sender);
  if PropertyName = 'Active' then
  begin
    btnMicOn.Visible := not Self.MainConfig.SpeechRec.Active;
    btnMicOff.Visible := Self.MainConfig.SpeechRec.Active;
  end;
end;

procedure TMaterialListForm.HandleSpeechRecCommand(Sender: TObject;
  SpeechRecCommand: TSpeechRecCommand; Parameters: TStrings);
begin
  if FVmPosForm <> nil then
  begin
    case SpeechRecCommand of
      srcAll:
        ;
      srcLast:
        ;
      srcNumber:
        ;
      srcStore:
        FVmPosForm.btnStorePosClick(nil);
      srcCancel:
        FVmPosForm.btnBackClick(nil);
    end;
  end;
end;

procedure TMaterialListForm.HandleSpeechRecNoresultMatch(Sender: TObject;
  Phrases: TStrings);
var
  s: string;
  Mat: TMatModel;
  lst: TMatList;
  procedure SuccessHandling(Sender: TObject);
  begin
    if Sender is TMatModel then
    begin
      Mat := Sender as TMatModel;
      lst.Add(Mat);
      Self.ContinueSuccess(Mat);
    end;
  end;
  procedure ErrorHandling(Sender: TObject; AMsg: string);
  begin
    Mat := lst.GetByCode(s);
    if Mat = nil then
      Self.HandleError(Mat, AMsg)
    else
      Self.ContinueSuccess(Mat);
  end;

begin
  s := Phrases[0];
  s := Trim(s);
  s := StringReplace(s, ' ', '', [rfReplaceAll]);
  if s <> '' then
  begin
    if FVmPosForm = nil then
    begin
      lst := TMatList.Create(true);
      Mat := TMatModel.Create;
      Mat.OnError := ErrorHandling;
      Mat.OnSuccess := SuccessHandling;
      Mat.GetByCode(Self.MainConfig.Uri, s);
    end
    else
      FVmPosForm.edtMenge.Text := s;
  end;
end;

procedure TMaterialListForm.SetFak(const Value: TFakModel);
begin
  FFak := Value;
end;

procedure TMaterialListForm.SetMainConfig(const Value: TMainConfig);
  procedure HandleSupport(Sender: TObject; IsSupported: Boolean);
  begin
    btnBarcode.Visible := IsSupported;
  end;

begin
  FMainConfig := Value;
  Self.MainConfig.CurrentForm := Self.Name;
  ColorComponents(Self, Self.MainConfig.ColorConfig);
  pnlFooter.Caption := Self.MainConfig.Copyright;
  Self.WebFormResize(Self);
  Self.MainConfig.SpeechRec.OnSpeechRecNoResultMatch :=
    Self.HandleSpeechRecNoresultMatch;
  Self.MainConfig.SpeechRec.OnSpeechRecCommand := Self.HandleSpeechRecCommand;
  Self.MainConfig.SpeechRec.OnPropertyChanged := Self.HandlePropertyChanged;
  Self.HandlePropertyChanged(Self, 'Active');
  FBarcodeScanner := TBarcodeScanner.Create(nil);
  FBarcodeScanner.OnSupported := HandleSupport;
  FBarcodeScanner.IsSupported;
  Self.VmPosList.Fak := Self.Fak;
  Self.VmPosList.PersonalNr := Self.MainConfig.User.PersonalNr;
  Self.VmPosList.Url := Self.MainConfig.Uri;
  Self.VmPosList.Load;
end;

procedure TMaterialListForm.SetReportMode(const Value: Boolean);
begin
  FReportMode := Value;
  pnlButtons.Visible := not Self.ReportMode;
end;

procedure TMaterialListForm.SetSelectedItem(const Value: TVmPosModel);
begin
  FSelectedItem := Value;
  pnlSmallButtons.Visible := false;
  pnlInfo.Visible := Self.SelectedItem <> nil;
  if Self.SelectedItem <> nil then
  begin
    pnlSmallButtons.Visible := (Self.SelectedItem.TransmittedAt = 0) and
      (Self.SelectedItem.PersonalNr = Self.MainConfig.User.PersonalNr);
    if Self.SelectedItem.Vorname <> '' then
      lblInfo.Caption := 'Erstellt von ' + Self.SelectedItem.Vorname + ' ' +
        Self.SelectedItem.Name + ' am ' +
        FormatdateTime('ddd. dd.mm.yyyy hh:nn', Self.SelectedItem.CreatedAt)
    else
      lblInfo.Caption := 'Erstellt von ' + Self.SelectedItem.Name + ' am ' +
        FormatdateTime('ddd. dd.mm.yyyy hh:nn', Self.SelectedItem.CreatedAt);
  end;
  Self.WebFormResize(Self);
end;

procedure TMaterialListForm.SetVmPosList(const Value: TVmPosList);
begin
  FVmPosList := Value;
end;

procedure TMaterialListForm.sgMaterialListClickCell(Sender: TObject;
  ACol, ARow: Integer);
begin
  if Self.ReportMode and (0 < ARow) and (ARow <= Self.VmPosList.Count) then
    Self.VmPosList.Items[ARow - 1].Selected := not Self.VmPosList.Items
      [ARow - 1].Selected;
end;

procedure TMaterialListForm.SgMaterialListFill(Sender: TObject);
var
  i: Integer;
  item: TVmPosModel;
begin
  if Sender is TVmPosList then
  begin
    Self.VmPosList := Sender as TVmPosList;
    btnTake.Visible := Self.VmPosList.AreItemsSelected;
    sgMaterialList.ColCount := 7;
    sgMaterialList.RowCount := Self.VmPosList.Count + 1;
    sgMaterialList.FixedCols := 0;
    sgMaterialList.FixedRows := 1;
    sgMaterialList.DefaultRowHeight := 32;
    sgMaterialList.ColWidths[0] := 5;
    sgMaterialList.ColWidths[1] := 32;
    sgMaterialList.ColWidths[2] := 85;
    sgMaterialList.ColWidths[3] := 40;
    sgMaterialList.ColWidths[4] := 5;
    sgMaterialList.ColWidths[5] := 50;
    sgMaterialList.ColWidths[6] := 250;
    sgMaterialList.Cells[2, 0] := Bold('Art.-Nr.');
    sgMaterialList.Cells[3, 0] := Bold('Menge');
    sgMaterialList.Cells[5, 0] := Bold('Einheit');
    sgMaterialList.Cells[6, 0] := Bold('Artikel');
    for i := 0 to Self.VmPosList.Count - 1 do
    begin
      item := Self.VmPosList.Items[i];
      if not Self.ReportMode then
      begin
        if item.TransmittedAt > 0 then
          sgMaterialList.Cells[1, i + 1] :=
            '<img src="Images\IconOk.png" style="width:16px;height:16px;">'
        else
          sgMaterialList.Cells[1, i + 1] := '';
      end
      else
      begin
        if item.Selected then
          sgMaterialList.Cells[1, i + 1] :=
            '<img src="Images\IconOk.png" style="width:16px;height:16px;">'
        else
          sgMaterialList.Cells[1, i + 1] := '';
      end;
      sgMaterialList.Cells[2, i + 1] := item.Mat.ArtNr;
      sgMaterialList.Cells[3, i + 1] :=
        AlignRight(Format('%.2n', [item.Menge]));
      sgMaterialList.Cells[5, i + 1] := item.Mat.MeEinheit;
      sgMaterialList.Cells[6, i + 1] := item.Mat.Bezeichnung;
    end;
  end;
end;

procedure TMaterialListForm.sgMaterialListSelectCell(Sender: TObject;
  ACol, ARow: Integer; var CanSelect: Boolean);
begin
  if not Self.ReportMode and (0 < ARow) and (ARow <= Self.VmPosList.Count) then
    Self.SelectedItem := Self.VmPosList.Items[ARow - 1]
  else
    Self.SelectedItem := nil;
end;

procedure TMaterialListForm.WebFormClose(Sender: TObject;
  var Action: TCloseAction);
begin
  if Self.MainConfig.SpeechRec.Active then
    Self.MainConfig.SpeechRec.Stopp;
  Self.MainConfig.SpeechRec.OnSpeechRecNoResultMatch := nil;
  Self.MainConfig.SpeechRec.OnSpeechRecCommand := nil;
  Self.MainConfig.SpeechRec.OnPropertyChanged := nil;
end;

procedure TMaterialListForm.WebFormCreate(Sender: TObject);
begin
  FVmPosForm := nil;
  FPosList := nil;
  Self.SelectedItem := nil;
  FSource := nil;
  Self.ReportMode := false;
  Self.VmPosList := TVmPosList.Create;
  Self.VmPosList.OnListChanged := Self.SgMaterialListFill;
  Self.VmPosList.OnPropertyChanged := Self.HandlePropertyChanged;
end;

procedure TMaterialListForm.WebFormOrientationChange(Sender: TObject;
  AOrientation: TScreenOrientation);
begin
  Self.WebFormResize(Sender);
end;

procedure TMaterialListForm.WebFormResize(Sender: TObject);
var
  t, h, l: Integer;
begin
  if (Self.Height < 480) or (Self.Width < 640) then
  begin
    btnBack.Width := 24;
    btnBack.Height := 24;
    btnBack.Top := 4;
    btnBack.Left := 4;
    lblHeader.Font.Size := 10;
    lblHeader.Top := 7;
    imgLogo.Width := 74;
    imgLogo.Height := 24;
    imgLogo.Top := 4;
    pnlHeader.Height := 32;
    pnlFooter.Visible := false;
    lblHeader.Caption := 'Materialliste';
    pnlButtons.Top := pnlHeader.Top + pnlHeader.Height;
    t := pnlButtons.Top + pnlButtons.Height;
    h := Self.ClientHeight - pnlHeader.Height - pnlButtons.Height;
    if pnlSmallButtons.Visible then
    begin
      pnlSmallButtons.Top := t;
      t := pnlSmallButtons.Top + pnlSmallButtons.Height;
      h := h - pnlSmallButtons.Height;
    end;
    if pnlInfo.Visible then
    begin
      pnlInfo.Top := t;
      t := pnlInfo.Top + pnlInfo.Height;
      h := h - pnlInfo.Height;
    end;
    pnlMaterialList.Top := t;
    pnlMaterialList.Height := h;
//    btnTake.Top := Self.ClientHeight - btnTake.Height - 48;
  end
  else
  begin
    btnBack.Width := 48;
    btnBack.Height := 48;
    btnBack.Top := 8;
    btnBack.Left := 8;
    lblHeader.Font.Size := 16;
    lblHeader.Top := 16;
    imgLogo.Width := 148;
    imgLogo.Height := 48;
    imgLogo.Top := 8;
    pnlHeader.Height := 64;
    pnlFooter.Visible := true;
    lblHeader.Caption := 'Winzeit - WebPortal - Materialliste';
    pnlButtons.Top := pnlHeader.Top + pnlHeader.Height;
    t := pnlButtons.Top + pnlButtons.Height;
    h := Self.ClientHeight - pnlHeader.Height - pnlButtons.Height;
    if pnlSmallButtons.Visible then
    begin
      pnlSmallButtons.Top := t;
      t := pnlSmallButtons.Top + pnlSmallButtons.Height;
      h := h - pnlSmallButtons.Height;
    end;
    if pnlInfo.Visible then
    begin
      pnlInfo.Top := t;
      t := pnlInfo.Top + pnlInfo.Height;
      h := h - pnlInfo.Height;
    end;
    pnlMaterialList.Top := t;
    pnlMaterialList.Height := h - pnlFooter.Height;
{    btnTake.Top := Self.ClientHeight - (2 * pnlFooter.Height) -
      btnTake.Height - 48;}
  end;
  pnlHeader.Width := Self.ClientWidth;
  pnlFooter.Width := pnlHeader.Width;
  lblHeader.Left := btnBack.Left + btnBack.Width + 8;
  lblHeader.Width := pnlHeader.ClientWidth - imgLogo.Width - 32;
  imgLogo.Left := pnlHeader.ClientWidth - imgLogo.Width - 16;
  pnlButtons.Width := Min(535, Self.ClientWidth);
  pnlSmallButtons.Width := pnlButtons.Width;
  pnlInfo.Width := pnlButtons.Width;
  pnlMaterialList.Width := pnlButtons.Width;
  l := (Self.ClientWidth - pnlButtons.Width) div 2;
  if l < 0 then
    l := 0;
  pnlButtons.Left := l;
  pnlSmallButtons.Left := pnlButtons.Left;
  pnlInfo.Left := pnlButtons.Left;
  pnlMaterialList.Left := pnlButtons.Left;
  btnMicOff.Left := btnMicOn.Left;
  btnLoad.Left := pnlButtons.ClientWidth - btnLoad.Width - 6;
  {btnTake.Left := pnlMaterialList.Left + pnlMaterialList.Width -
    btnTake.Width - 24;}
end;

procedure TMaterialListForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlHeader := TPanel.Create(Self);
  imgLogo := TImageControl.Create(Self);
  lblHeader := TLabel.Create(Self);
  btnBack := TImageControl.Create(Self);
  pnlFooter := TPanel.Create(Self);
  pnlButtons := TPanel.Create(Self);
  btnBarcode := TBitBtn.Create(Self);
  btnMicOn := TBitBtn.Create(Self);
  btnMicOff := TBitBtn.Create(Self);
  btnKeyboard := TBitBtn.Create(Self);
  btnLoad := TBitBtn.Create(Self);
  pnlMaterialList := TPanel.Create(Self);
  sgMaterialList := TStringGrid.Create(Self);
  btnTake := TBitBtn.Create(Self);
  pnlSmallButtons := TPanel.Create(Self);
  btnEdit := TBitBtn.Create(Self);
  btnDelete := TBitBtn.Create(Self);
  pnlInfo := TPanel.Create(Self);
  lblInfo := TLabel.Create(Self);

  pnlHeader.BeforeLoadDFMValues;
  imgLogo.BeforeLoadDFMValues;
  lblHeader.BeforeLoadDFMValues;
  btnBack.BeforeLoadDFMValues;
  pnlFooter.BeforeLoadDFMValues;
  pnlButtons.BeforeLoadDFMValues;
  btnBarcode.BeforeLoadDFMValues;
  btnMicOn.BeforeLoadDFMValues;
  btnMicOff.BeforeLoadDFMValues;
  btnKeyboard.BeforeLoadDFMValues;
  btnLoad.BeforeLoadDFMValues;
  pnlMaterialList.BeforeLoadDFMValues;
  sgMaterialList.BeforeLoadDFMValues;
  btnTake.BeforeLoadDFMValues;
  pnlSmallButtons.BeforeLoadDFMValues;
  btnEdit.BeforeLoadDFMValues;
  btnDelete.BeforeLoadDFMValues;
  pnlInfo.BeforeLoadDFMValues;
  lblInfo.BeforeLoadDFMValues;
  try
    Name := 'MaterialListForm';
    Width := 640;
    Height := 480;
    Caption := 'Berichte';
    SetEvent(Self, 'OnClose', 'WebFormClose');
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnOrientationChange', 'WebFormOrientationChange');
    SetEvent(Self, 'OnResize', 'WebFormResize');
    pnlHeader.SetParentComponent(Self);
    pnlHeader.Name := 'pnlHeader';
    pnlHeader.Left := 0;
    pnlHeader.Top := 0;
    pnlHeader.Width := 640;
    pnlHeader.Height := 64;
    pnlHeader.Align := alTop;
    pnlHeader.Caption := 'pnlHeader';
    pnlHeader.ChildOrder := 4;
    pnlHeader.Color := clSkyBlue;
    pnlHeader.ShowCaption := False;
    imgLogo.SetParentComponent(pnlHeader);
    imgLogo.Name := 'imgLogo';
    imgLogo.Left := 480;
    imgLogo.Top := 8;
    imgLogo.Width := 148;
    imgLogo.Height := 48;
    imgLogo.HeightPercent := 100.000000000000000000;
    imgLogo.WidthPercent := 100.000000000000000000;
    imgLogo.Picture.LoadFromFile('UMaterialListForm.pnlHeader.imgLogo.Picture.png');
    lblHeader.SetParentComponent(pnlHeader);
    lblHeader.Name := 'lblHeader';
    lblHeader.Left := 64;
    lblHeader.Top := 16;
    lblHeader.Width := 410;
    lblHeader.Height := 30;
    lblHeader.Alignment := taCenter;
    lblHeader.AutoSize := False;
    lblHeader.Caption := 'Winzeit - WebPortal - Materialliste';
    lblHeader.Font.Charset := DEFAULT_CHARSET;
    lblHeader.Font.Color := clWindowText;
    lblHeader.Font.Height := -21;
    lblHeader.Font.Name := 'Segoe UI';
    lblHeader.Font.Style := [fsBold];
    lblHeader.HeightPercent := 100.000000000000000000;
    lblHeader.ParentFont := False;
    lblHeader.WidthPercent := 100.000000000000000000;
    btnBack.SetParentComponent(pnlHeader);
    btnBack.Name := 'btnBack';
    btnBack.Left := 16;
    btnBack.Top := 16;
    btnBack.Width := 32;
    btnBack.Height := 32;
    btnBack.HeightPercent := 100.000000000000000000;
    btnBack.WidthPercent := 100.000000000000000000;
    btnBack.ChildOrder := 2;
    SetEvent(btnBack, Self, 'OnClick', 'btnBackClick');
    btnBack.Picture.LoadFromFile('UMaterialListForm.pnlHeader.btnBack.Picture.png');
    pnlFooter.SetParentComponent(Self);
    pnlFooter.Name := 'pnlFooter';
    pnlFooter.Left := 0;
    pnlFooter.Top := 456;
    pnlFooter.Width := 640;
    pnlFooter.Height := 24;
    pnlFooter.Align := alBottom;
    pnlFooter.Alignment := taLeftJustify;
    pnlFooter.Caption := 'pnlFooter';
    pnlFooter.ChildOrder := 1;
    pnlFooter.Color := clSkyBlue;
    pnlButtons.SetParentComponent(Self);
    pnlButtons.Name := 'pnlButtons';
    pnlButtons.Left := 0;
    pnlButtons.Top := 64;
    pnlButtons.Width := 640;
    pnlButtons.Height := 48;
    pnlButtons.Caption := 'pnlButtons';
    pnlButtons.ChildOrder := 2;
    pnlButtons.ShowCaption := False;
    btnBarcode.SetParentComponent(pnlButtons);
    btnBarcode.Name := 'btnBarcode';
    btnBarcode.Left := 92;
    btnBarcode.Top := 4;
    btnBarcode.Width := 40;
    btnBarcode.Height := 40;
    btnBarcode.Hint := 'Barcode scannen';
    btnBarcode.Color := clNone;
    btnBarcode.Glyph.LoadFromFile('UMaterialListForm.pnlButtons.btnBarcode.Glyph.png');
    btnBarcode.GlyphSize := 32;
    btnBarcode.HeightPercent := 100.000000000000000000;
    btnBarcode.ShowHint := True;
    btnBarcode.WidthPercent := 100.000000000000000000;
    SetEvent(btnBarcode, Self, 'OnClick', 'btnBarcodeClick');
    btnMicOn.SetParentComponent(pnlButtons);
    btnMicOn.Name := 'btnMicOn';
    btnMicOn.Left := 4;
    btnMicOn.Top := 4;
    btnMicOn.Width := 40;
    btnMicOn.Height := 40;
    btnMicOn.Hint := 'Spracheingabe';
    btnMicOn.Color := clNone;
    btnMicOn.Glyph.LoadFromFile('UMaterialListForm.pnlButtons.btnMicOn.Glyph.png');
    btnMicOn.GlyphSize := 32;
    btnMicOn.HeightPercent := 100.000000000000000000;
    btnMicOn.ShowHint := True;
    btnMicOn.WidthPercent := 100.000000000000000000;
    SetEvent(btnMicOn, Self, 'OnClick', 'btnMicOnClick');
    btnMicOff.SetParentComponent(pnlButtons);
    btnMicOff.Name := 'btnMicOff';
    btnMicOff.Left := 12;
    btnMicOff.Top := 4;
    btnMicOff.Width := 40;
    btnMicOff.Height := 40;
    btnMicOff.Hint := 'Mikrofon aus';
    btnMicOff.Color := clNone;
    btnMicOff.Glyph.LoadFromFile('UMaterialListForm.pnlButtons.btnMicOff.Glyph.png');
    btnMicOff.GlyphSize := 32;
    btnMicOff.HeightPercent := 100.000000000000000000;
    btnMicOff.ShowHint := True;
    btnMicOff.Visible := False;
    btnMicOff.WidthPercent := 100.000000000000000000;
    SetEvent(btnMicOff, Self, 'OnClick', 'btnMicOffClick');
    btnKeyboard.SetParentComponent(pnlButtons);
    btnKeyboard.Name := 'btnKeyboard';
    btnKeyboard.Left := 48;
    btnKeyboard.Top := 4;
    btnKeyboard.Width := 40;
    btnKeyboard.Height := 40;
    btnKeyboard.Hint := 'Tastatureingabe';
    btnKeyboard.Color := clNone;
    btnKeyboard.Glyph.LoadFromFile('UMaterialListForm.pnlButtons.btnKeyboard.Glyph.png');
    btnKeyboard.GlyphSize := 32;
    btnKeyboard.HeightPercent := 100.000000000000000000;
    btnKeyboard.ShowHint := True;
    btnKeyboard.WidthPercent := 100.000000000000000000;
    SetEvent(btnKeyboard, Self, 'OnClick', 'btnKeyboardClick');
    btnLoad.SetParentComponent(pnlButtons);
    btnLoad.Name := 'btnLoad';
    btnLoad.Left := 580;
    btnLoad.Top := 4;
    btnLoad.Width := 40;
    btnLoad.Height := 40;
    btnLoad.Hint := 'Liste aktualisieren';
    btnLoad.Color := clNone;
    btnLoad.Glyph.LoadFromFile('UMaterialListForm.pnlButtons.btnLoad.Glyph.png');
    btnLoad.GlyphSize := 32;
    btnLoad.HeightPercent := 100.000000000000000000;
    btnLoad.ShowHint := True;
    btnLoad.WidthPercent := 100.000000000000000000;
    SetEvent(btnLoad, Self, 'OnClick', 'btnLoadClick');
    pnlMaterialList.SetParentComponent(Self);
    pnlMaterialList.Name := 'pnlMaterialList';
    pnlMaterialList.Left := 0;
    pnlMaterialList.Top := 167;
    pnlMaterialList.Width := 640;
    pnlMaterialList.Height := 289;
    pnlMaterialList.Caption := 'pnlMaterialList';
    pnlMaterialList.ChildOrder := 3;
    pnlMaterialList.ShowCaption := False;
    sgMaterialList.SetParentComponent(pnlMaterialList);
    sgMaterialList.Name := 'sgMaterialList';
    sgMaterialList.Left := 0;
    sgMaterialList.Top := 0;
    sgMaterialList.Width := 640;
    sgMaterialList.Height := 289;
    sgMaterialList.Align := alClient;
    sgMaterialList.Options := [goFixedHorzLine,goHorzLine,goRangeSelect,goColSizing,goRowSelect,goFixedRowDefAlign];
    sgMaterialList.TabOrder := 0;
    SetEvent(sgMaterialList, Self, 'OnSelectCell', 'sgMaterialListSelectCell');
    sgMaterialList.RangeEdit.Max := 100.000000000000000000;
    sgMaterialList.RangeEdit.Step := 1.000000000000000000;
    sgMaterialList.HeightPercent := 100.000000000000000000;
    sgMaterialList.WidthPercent := 100.000000000000000000;
    SetEvent(sgMaterialList, Self, 'OnClickCell', 'sgMaterialListClickCell');
    btnTake.SetParentComponent(pnlMaterialList);
    btnTake.Name := 'btnTake';
    btnTake.Left := 579;
    btnTake.Top := 232;
    btnTake.Width := 40;
    btnTake.Height := 40;
    btnTake.Hint := #220'bernehmen';
    btnTake.Anchors := [akRight,akBottom];
    btnTake.Color := clNone;
    btnTake.ElementClassName := 'btnMicro';
    btnTake.Glyph.LoadFromFile('UMaterialListForm.pnlMaterialList.btnTake.Glyph.png');
    btnTake.GlyphSize := 32;
    btnTake.HeightPercent := 100.000000000000000000;
    btnTake.ShowHint := True;
    btnTake.WidthPercent := 100.000000000000000000;
    SetEvent(btnTake, Self, 'OnClick', 'btnTakeClick');
    pnlSmallButtons.SetParentComponent(Self);
    pnlSmallButtons.Name := 'pnlSmallButtons';
    pnlSmallButtons.Left := 0;
    pnlSmallButtons.Top := 112;
    pnlSmallButtons.Width := 640;
    pnlSmallButtons.Height := 32;
    pnlSmallButtons.Caption := 'pnlSmallButtons';
    pnlSmallButtons.ChildOrder := 4;
    pnlSmallButtons.ShowCaption := False;
    btnEdit.SetParentComponent(pnlSmallButtons);
    btnEdit.Name := 'btnEdit';
    btnEdit.Left := 4;
    btnEdit.Top := 4;
    btnEdit.Width := 24;
    btnEdit.Height := 24;
    btnEdit.Hint := 'Bearbeiten';
    btnEdit.Color := clNone;
    btnEdit.Glyph.LoadFromFile('UMaterialListForm.pnlSmallButtons.btnEdit.Glyph.png');
    btnEdit.GlyphSize := 16;
    btnEdit.HeightPercent := 100.000000000000000000;
    btnEdit.ShowHint := True;
    btnEdit.WidthPercent := 100.000000000000000000;
    SetEvent(btnEdit, Self, 'OnClick', 'btnEditClick');
    btnDelete.SetParentComponent(pnlSmallButtons);
    btnDelete.Name := 'btnDelete';
    btnDelete.Left := 32;
    btnDelete.Top := 4;
    btnDelete.Width := 24;
    btnDelete.Height := 24;
    btnDelete.Hint := 'L'#246'schen';
    btnDelete.Color := clNone;
    btnDelete.Glyph.LoadFromFile('UMaterialListForm.pnlSmallButtons.btnDelete.Glyph.png');
    btnDelete.GlyphSize := 16;
    btnDelete.HeightPercent := 100.000000000000000000;
    btnDelete.ShowHint := True;
    btnDelete.WidthPercent := 100.000000000000000000;
    SetEvent(btnDelete, Self, 'OnClick', 'btnDeleteClick');
    pnlInfo.SetParentComponent(Self);
    pnlInfo.Name := 'pnlInfo';
    pnlInfo.Left := 0;
    pnlInfo.Top := 144;
    pnlInfo.Width := 640;
    pnlInfo.Height := 23;
    pnlInfo.Caption := 'pnlInfo';
    pnlInfo.ChildOrder := 5;
    pnlInfo.ShowCaption := False;
    lblInfo.SetParentComponent(pnlInfo);
    lblInfo.Name := 'lblInfo';
    lblInfo.Left := 4;
    lblInfo.Top := 4;
    lblInfo.Width := 34;
    lblInfo.Height := 15;
    lblInfo.Caption := 'lblInfo';
    lblInfo.HeightPercent := 100.000000000000000000;
    lblInfo.WidthPercent := 100.000000000000000000;
  finally
    pnlHeader.AfterLoadDFMValues;
    imgLogo.AfterLoadDFMValues;
    lblHeader.AfterLoadDFMValues;
    btnBack.AfterLoadDFMValues;
    pnlFooter.AfterLoadDFMValues;
    pnlButtons.AfterLoadDFMValues;
    btnBarcode.AfterLoadDFMValues;
    btnMicOn.AfterLoadDFMValues;
    btnMicOff.AfterLoadDFMValues;
    btnKeyboard.AfterLoadDFMValues;
    btnLoad.AfterLoadDFMValues;
    pnlMaterialList.AfterLoadDFMValues;
    sgMaterialList.AfterLoadDFMValues;
    btnTake.AfterLoadDFMValues;
    pnlSmallButtons.AfterLoadDFMValues;
    btnEdit.AfterLoadDFMValues;
    btnDelete.AfterLoadDFMValues;
    pnlInfo.AfterLoadDFMValues;
    lblInfo.AfterLoadDFMValues;
  end;
end;

end.
